// extracted by mini-css-extract-plugin
export default {"error":"DetailServices_error__ha8bf"};